import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading || user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        data-testid="auth-loading"
      >
        <div
          className="h-8 w-8 rounded-full border-2 animate-spin"
          style={{ borderColor: "var(--caa-deep-teal)", borderTopColor: "transparent" }}
        />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password && loc.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  return children;
};

export default ProtectedRoute;
